module.exports = __webpack_public_path__ + "img/angry-active.ab295074.svg";